import { countRepos, getRepoTagCatalog, listRepos, type TagCatalog } from '@mesa/core/repo/queries';
import { createServerFn } from '@tanstack/react-start';
import { log } from '../../lib/logger';
import { assertScope, baseAuthMiddleware } from '../../middleware/base-auth';

export const loadRepoListPage = createServerFn({ method: 'GET' })
  .middleware([baseAuthMiddleware])
  .inputValidator(
    (data: {
      orgSlug: string;
      tags?: string[];
      search?: string;
      cursor?: string;
      sortBy?: 'name' | 'createdAt';
      sortOrder?: 'asc' | 'desc';
    }) => data
  )
  .handler(async ({ data, context }) => {
    assertScope(context.member.role, 'read');
    const orgId = context.org.id;

    const [repoResult, tagCatalog, totalCount] = await Promise.all([
      listRepos(orgId, {
        tags: data.tags?.length ? data.tags.join(',') : undefined,
        search: data.search || undefined,
        cursor: data.cursor,
        limit: 10,
        sortBy: data.sortBy,
        sortOrder: data.sortOrder,
      }),
      // Tags are cosmetic — don't let a tag catalog failure kill the repo list
      getRepoTagCatalog(orgId).catch((err): TagCatalog => {
        log.warn('tag-catalog-failed', { orgId, error: String(err) });
        return {};
      }),
      countRepos(orgId, {
        tags: data.tags?.length ? data.tags.join(',') : undefined,
        search: data.search || undefined,
      }),
    ]);

    return {
      repos: repoResult.repos,
      nextCursor: repoResult.nextCursor,
      hasMore: repoResult.hasMore,
      tagsByRepo: repoResult.tagsByRepo,
      tagCatalog,
      totalCount,
    };
  });
